import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "closed-deposit-detail-table px-4 py-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "SNACK"),
  /*#__PURE__*/_createElementVNode("th", null, "HARGA"),
  /*#__PURE__*/_createElementVNode("th", null, "TERJUAL"),
  /*#__PURE__*/_createElementVNode("th", null, "SISA"),
  /*#__PURE__*/_createElementVNode("th", null, "PENDAPATAN")
], -1)
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "text-center text-xs text-grey p-2",
  style: {"text-align":"center"}
}, "Tidak Ada Data", -1)
const _hoisted_7 = [
  _hoisted_6
]

import { ref, computed, onMounted, getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import apiUseCase from '@/usecase/apiUseCase'
import numberFormat from '@/utils/helpers/numberFormat'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import currencyNumberFormat from '@/utils/helpers/rupiahFormat'
import Paginator from '@/views/components/paginator/Paginator.vue'
import defaulListImage from '@/assets/img/icon/cross-black-background-grey.svg'
import environment from '@/configs/environtment'
import changeImagePathPrefix from '@/utils/helpers/changeImagePathPrefix'
import '../../detail-table.scss'


export default /*#__PURE__*/_defineComponent({
  __name: 'SnackListDetail',
  props: {
  transactionId: {
    type: String,
    default: null
  }
},
  setup(__props) {

const props = __props



const transactionPpsEndpoint = 'transaction/v2/TransactionPps'
const app = getCurrentInstance()
const {
  $toast, $strInd, $icon
} = app!.appContext.config.globalProperties
const icon = $icon
const dataSource = ref()
const snackList = ref([]) as any
const store = useStore()
const transactionId = computed(() => props.transactionId)
const inputSearch = ref('')

const dataDummy = ref([
  {
    id: '0',
    image: null,
    name: 'snack 1',
    price: 10000,
    snackSold: 10,
    snackRemaining: 100,
    income: 1000000
  },
  {
    id: '1',
    image: null,
    name: 'snack 2',
    price: 10000,
    snackSold: 10,
    snackRemaining: 100,
    income: 1000000
  },
  {
    id: '2',
    image: null,
    name: 'snack 3',
    price: 10000,
    snackSold: 10,
    snackRemaining: 100,
    income: 1000000
  },
])

const getAllData = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${transactionPpsEndpoint}/Snack/Summary/ByTransactionPp/${transactionId.value}`).then((response) => {
    const { error, result, count } = response
    console.log('res', result)
    if (!error) {
      dataSource.value = result
      snackList.value = result?.TransactionPpSnackStocks.map((data: any) => ({
        ...data,
        Image: data.SnackImage ? `${environment.getApiImageBaseUrl()}${changeImagePathPrefix(data.SnackImage)}` : null,
      }))
    }
  })
  store.dispatch('hideLoading')
}

const onSearch = () => {
  if (inputSearch.value === '') {
    snackList.value = dataSource.value?.TransactionPpSnackStocks.map((data: any) => ({
      ...data,
      Image: data.SnackImage ? `${environment.getApiImageBaseUrl()}${changeImagePathPrefix(data.SnackImage)}` : null,
    }))
  } else {
    snackList.value.filter((data: any) => data.SnackName.toLowerCase() === inputSearch.value.toLowerCase())
  }
}

onMounted(() => {
  getAllData()
})

return (_ctx: any,_cache: any) => {
  const _component_InputIconRight = _resolveComponent("InputIconRight")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_InputIconRight, {
      class: "input-search-header-custom",
      placeholder: "Cari Disini...",
      modelValue: inputSearch.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputSearch).value = $event)),
      canClick: true,
      icon: _unref($icon).svg.searchEva,
      onSubmitInput: onSearch,
      onKeyup: _withKeys(onSearch, ["enter"])
    }, null, 8, ["modelValue", "icon", "onKeyup"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", null, [
        _hoisted_2,
        (_unref(snackList).length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(snackList), (data) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: data.Id
              }, [
                _createElementVNode("td", _hoisted_3, [
                  _createElementVNode("img", {
                    src: data.Image ?? _unref(defaulListImage),
                    class: "rounded-lg",
                    style: _normalizeStyle(data.image ? 'width: 50px;' : 'width: 40px;'),
                    alt: "SnackThumbnail"
                  }, null, 12, _hoisted_4),
                  _createElementVNode("div", null, _toDisplayString(data.SnackName ?? '-'), 1)
                ]),
                _createElementVNode("td", null, _toDisplayString(_unref(currencyNumberFormat)(data.SnackPrice ?? 0)), 1),
                _createElementVNode("td", null, _toDisplayString(`${_unref(numberFormat)(data.SoldQuantity ?? 0)} Pack`), 1),
                _createElementVNode("td", null, _toDisplayString(`${_unref(numberFormat)(data.CurrentStock ?? 0)} Pack`), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(currencyNumberFormat)(data.SoldAmount ?? 0)), 1)
              ]))
            }), 128))
          : (_openBlock(), _createElementBlock("tr", _hoisted_5, _hoisted_7))
      ])
    ])
  ]))
}
}

})